import { render, staticRenderFns } from "./StockPurchaseOrderRequestReview.vue?vue&type=template&id=ef06d102&"
import script from "./StockPurchaseOrderRequestReview.vue?vue&type=script&lang=js&"
export * from "./StockPurchaseOrderRequestReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VOverlay,VProgressCircular})
